/**
 * Codes pays supportés par la plateforme (profil prestataire, recherche, filtres).
 * Format ISO 3166-1 alpha-2 en majuscules.
 * Périmètre : Benelux, France, DACH, pays du Nord, UK, Portugal, Espagne, Italie,
 * Congo (RDC + Brazzaville), reste de l'Afrique francophone.
 */

const PLATFORM_COUNTRY_CODES_RAW = [
  // Benelux
  'BE',
  'NL',
  'LU',
  // France
  'FR',
  // DACH
  'DE',
  'AT',
  'CH',
  // Pays du Nord
  'NO',
  'SE',
  'DK',
  'FI',
  'IS',
  // UK, Portugal, Espagne, Italie
  'GB',
  'PT',
  'ES',
  'IT',
  // Congo
  'CD',
  'CG',
  // Afrique francophone
  'SN',
  'CI',
  'BF',
  'BJ',
  'TG',
  'NE',
  'ML',
  'MR',
  'MG',
  'CM',
  'CF',
  'GA',
  'DJ',
  'KM',
  'BI',
  'RW',
  'TD',
  'GN',
  'MU',
  'SC',
];

/** Codes pays valides pour la localisation (ville / adresse) et le champ country des profils */
export const PLATFORM_COUNTRY_CODES = [...PLATFORM_COUNTRY_CODES_RAW];

/** Pour les APIs Google (Places) : mêmes codes en minuscules */
export const PLATFORM_COUNTRY_CODES_LOWER = PLATFORM_COUNTRY_CODES.map((c) => c.toLowerCase());

/** Vérifie si un code pays est supporté (insensible à la casse) */
export function isPlatformCountry(code) {
  if (!code || typeof code !== 'string') return false;
  return PLATFORM_COUNTRY_CODES.includes(code.trim().toUpperCase());
}

/** Retourne le code en majuscules si supporté, sinon null */
export function normalizePlatformCountry(code) {
  if (!code || typeof code !== 'string') return null;
  const upper = code.trim().toUpperCase();
  return PLATFORM_COUNTRY_CODES.includes(upper) ? upper : null;
}

/** Libellé du pays pour l’affichage (locale par défaut: fr) */
export function getCountryLabel(countryCode, locale = 'fr') {
  if (!countryCode || typeof countryCode !== 'string') return '';
  const upper = countryCode.trim().toUpperCase();
  if (!PLATFORM_COUNTRY_CODES.includes(upper)) return upper;
  try {
    return new Intl.DisplayNames([locale], { type: 'region' }).of(upper) || upper;
  } catch {
    return upper;
  }
}
